module.exports = __webpack_public_path__ + "img/unlink_icon.4ac1a835.png";